import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import RegisterYourCompany from '../../components/mainpage/subcomponent/RegisterYourCompany';
const RegisterYourCompanyModal = ({
    showModal, setShowModal
}) => {
    const handleClose = () => {
        setShowModal(false)
    };
    return (
        <>
            <Modal show={showModal} onHide={handleClose}
                aria-labelledby="example-custom-modal-styling-title"
                dialogClassName="modal-width"
                centered
                animation={true}>
                <Modal.Body>
                    <div style={{ float: "right", fontSize: '20px' }}><CloseButton onClick={handleClose} /></div>
                    <RegisterYourCompany handleClose={handleClose} />
                </Modal.Body>
            </Modal>
        </>
    );
}
export default RegisterYourCompanyModal;